<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>MEDIOS DE PAGO</span>
      <v-spacer></v-spacer>
      <v-chip
        v-if="reciboSeleccionado"
        :color="colorChipPagado()"
        text-color="white"
        class="caption"
      >Pagado: {{ importePagado | currency }} /
        {{ reciboSeleccionado.importe | currency }}</v-chip>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text
      style="height: 100%;"
      class="pa-0"
    >
      <v-container
        grid-list-md
        v-if="puedo('modif') && itemSeleccionado && !mostrarListado"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="date"
              v-model="itemSeleccionado.fecha"
              label="Fecha"
              v-validate="{ required: true }"
              :data-vv-name="'fecha'"
              :error-messages="errors.collect('fecha')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="number"
              prefix="$"
              v-model="itemSeleccionado.importe"
              label="Importe"
              v-validate="'required|min_value:1'"
              :data-vv-name="'importe'"
              :error-messages="errors.collect('importe')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
              :hint="$options.filters.currency(itemSeleccionado.importe)"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.tipo_pago_id"
              :items="info.tiposPago"
              item-text="nombre"
              item-value="id"
              label="Tipo de pago"
              v-validate="{ required: true }"
              :data-vv-name="'tiposPago'"
              :error-messages="errors.collect('tiposPago')"
              data-vv-validate-on="blur"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              :rows="2"
              v-model="itemSeleccionado.descripcion"
              label="Descripcion"
              v-validate="{ required: false }"
              :data-vv-name="'descripcion'"
              :error-messages="errors.collect('descripcion')"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table
        v-if="mostrarListado"
        hide-actions
        hide-details
        :headers-length="headers.length + 1"
        :headers="headers"
        :items="items"
        :total-items="items.length"
        :loading="cargando"
        class="elevation-1"
      >
        <v-progress-linear
          v-slot:progress
          color="blue"
          indeterminate
          v-if="cargando"
        ></v-progress-linear>
        <data-table-header
          slot="headers"
          slot-scope="props"
          :headers="props.headers"
          :paginacion="paginacion"
        >
          <v-btn
            v-if="puedo('alta')"
            class="white--text"
            round
            color="primary"
            @click="nuevo"
          >
            <v-icon
              dark
              small
              class="mr-2"
            >add</v-icon>Nuevo
          </v-btn>
        </data-table-header>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left pa1">{{ props.item.fecha | formatoFecha }}</td>
            <td class="text-xs-left pa1">{{ props.item.tipo_pago.nombre }}</td>
            <td class="text-xs-left pa1">{{ props.item.descripcion }}</td>
            <td class="text-xs-right pa1">{{ props.item.importe | currency }}</td>
            <td class="justify-end layout">
              <v-btn
                icon
                flat
                small
                color="blue-grey"
                class="mx-0"
                :disabled="!puedo('modif')"
                @click="editar(props.item)"
              >
                <v-icon small>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                icon
                flat
                small
                color="blue-grey"
                class="mx-0"
                :disabled="!puedo('modif')"
                @click="eliminar(props.item)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="mostrarBotonGuardar"
        v-bind:texto-cancelar="!mostrarListado ? 'Cancelar' : 'Cerrar'"
        v-on:alGuardar="guardar"
        v-on:alCancelar="alCerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import _ from 'lodash'
import { formatoFecha, fechaLocal } from '@/helpers/filtros'
import abmFormularioMixin from '@/mixins/abmFormulario'
// import Modelo from '@/api/recibo'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'

export default {
  name: 'ReciboPagos',

  mixins: [abmFormularioMixin],
  components: {
    BotonesCancelarGuardar
  },
  filters: {
    formatoFecha
  },
  props: {
    reciboId: {
      type: Number,
      required: true
    }
  },
  computed: {
    importePagado () {
      let importe = 0
      _.forEach(this.items, pago => {
        importe += Number(pago.importe)
      })
      return importe.toFixed(2)
    },
    saldo () {
      if (this.reciboSeleccionado) {
        return (this.reciboSeleccionado.importe - this.importePagado).toFixed(2)
      } else {
        return 0
      }
    },
    mostrarBotonGuardar () {
      return !this.mostrarListado && this.itemSeleccionado && Number(this.itemSeleccionado.importe) <= Number(this.saldo)
    }
  },
  data () {
    return {
      cargando: false,
      reciboSeleccionado: null,
      mostrarListado: true,
      montarMixin: false,
      filtros: {
        search: null
      },
      info: {
        tiposPago: []
      },
      totalItems: 0,
      headers: [
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Tipo de pago', value: 'tipo_pago_id', sortable: false },
        { text: 'Descripción', value: 'descripcion', sortable: false },
        { text: 'Importe', value: 'importe', sortable: false, align: 'right' }
      ],
      items: [],
      paginacion: {},
      itemsPorPagina: [20, 50, 100]
    }
  },
  mounted () {
    let vm = this
    vm.cargarInfo()
    // vm.filtrar()
  },
  methods: {
    cargarInfo () {
      let vm = this

      vm.modeloApi.obtener(vm.reciboId).then(
        data => {
          vm.reciboSeleccionado = data
          vm.reciboSeleccionado.importe = Number(this.reciboSeleccionado.importe).toFixed(2)
          vm.filtrar(vm.reciboSeleccionado.pagos)
          let dataCombos = {
            grupoEntidades: {
              tiposPago: {
                codigo: 'tipo_pago',
                itemVacio: true
              }
            }
          }

          vm.cargarCombos(dataCombos)
          // vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    cargarCombos (dataCombos, cargaOrigen) {
      let vm = this
      Combo.listado(dataCombos).then(
        data => {
          vm.info = _.assign(vm.info, data)
          vm.cargando = false
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },

    alCerrar () {
      if (!this.mostrarListado) {
        this.$validator.reset()
        this.itemSeleccionado = null
        this.mostrarListado = true
      } else {
        this.cerrar()
      }
    },
    metodoGuardar (datos) {
      return this.modeloApi.guardarPago(this.reciboId, datos)
    },
    alGuardar (items) {
      this.$validator.reset()
      this.filtrar(items)
      this.itemSeleccionado = null
      this.mostrarListado = true
    },
    nuevo () {
      let vm = this
      vm.itemSeleccionado = vm.nuevoItemSeleccionado()
      vm.mostrarListado = false
    },
    editar (item) {
      let vm = this
      vm.itemSeleccionado = _.cloneDeep(item)
      vm.mostrarListado = false
    },
    eliminar (item) {
      let vm = this

      if (confirm('Desea eliminar el registro?')) {
        vm.cargando = true
        vm.modeloApi
          .eliminarPago(vm.reciboId, item.id)
          .then(items => {
            vm.mostrarMensajeOk()
            vm.cargando = false
            vm.filtrar(items)
          })
          .catch(error => {
            this.$emit('mostrarError', error)
            vm.cargando = false
          })
      }
    },
    filtrar (items) {
      this.items.lenght = 0
      this.items = items
    },
    nuevoItemSeleccionado () {
      return _.cloneDeep({
        id: 0,
        tipo_pago_id: null,
        tipo_pago: {},
        fecha: fechaLocal('YYYY-MM-DD'),
        importe: this.saldo,
        descripcion: null
      })
    },
    colorChipPagado () {
      let color = 'red darken-2'
      if (this.items.length > 0) {
        if (this.importePagado === this.reciboSeleccionado.importe) {
          color = 'green darken-2'
        } else {
          color = 'orange darken-2'
        }
      }
      return color
    }
  }
}
</script>
<style scoped></style>
